import classNames from 'classnames';
import { GameData, STORAGE_URL } from 'react-easyrocket';
import { STORAGE_FOR_GAMES } from 'src/api';
import { useHideBlockedImage } from '../hooks/useHideBlockedImage';
interface GameImageProps {
  className?: string;
  game: GameData;
}

export const GameImage = ({ className, game }: GameImageProps) => {
  const { imagine, image, name } = game || {};
  const isHideBlockedImage = useHideBlockedImage({ game });

  const desktopSrc = isHideBlockedImage ? imagine?.files?.mobile : imagine?.files?.desktop;
  const mobileSrc = imagine?.files?.mobile;
  const defaultSrc = STORAGE_URL + STORAGE_FOR_GAMES + image;
  const imageAlt = imagine?.alt || game.name;

  return (
    <picture>
      {desktopSrc && <source media="(min-width:1024px)" srcSet={desktopSrc} />}
      {mobileSrc && <source media="(max-width:1023px)" srcSet={mobileSrc} />}
      <img
        src={defaultSrc}
        alt={imageAlt}
        title={name}
        draggable={false}
        decoding="async"
        className={classNames('aspect-[29/40] w-full z-[2] rounded-md', className)}
      />
    </picture>
  );
};
